import React from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
import CommonIcon from "../../helpers/icons";
import Chart from "react-apexcharts";
// import Autocomplete from "react-autocomplete";
import API from "../../helpers/endpointservice";
import axios from "axios";
import { colors } from "../../helpers/Constants";
import LoaderVisible from "../../helpers/loader";
// import PaginationComponent from "../../helpers/Pagination";
import { logoutFunction } from "../../custom/logoutFunction";
import Select from "react-select";
import InfoIcon from "@mui/icons-material/Info";

class SkillOverview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "asc",
      sortBy: "requestedDate",
      // options : { labels: ["Master", "Competent", "Learning"] },

      // data : [
      //   ["Job skills competency", "Percentage" ],
      //   ["Master", 60 ],
      //   ["Competent", 30 ],
      //   ["Learning", 10],
      // ],
      options: {
        dataLabels: {
          enabled: true,
          formatter: function (val, option) {
            if (option?.w?.globals?.initialSeries?.length == 6) {
            } else {
              return val.toFixed(2) + "%";
            }
          },
        },
        legend: false,
        labels: [
          "Master",
          "Competent",
          "Learner",
          "Novice",
          "NA",
          "No records",
        ],
        //       legend: { position: "right" ,
        onItemHover: {
          highlightDataSeries: false,
        },
        //     onItemClick: {
        //       toggleDataSeries: false
        //   },
        //   inverseOrder: false,
        //   horizontalAlign: 'center',
        //   verticalAlign: "center",
        //   itemMargin: {
        //     horizontal: 5,
        //     vertical: 5
        // },
        // },
        colors: [
          colors.GREEN,
          colors.BLUE,
          colors.ORANGE,
          colors.YELLOW,
          colors.BROWN,
          colors.GREY,
        ],
        // fill: ["#D12232", "#ED4454", "#FF838E"],
        stroke: {
          width: 0,
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
          },
        },
      },
      skills: [
        {
          value: 1,
          label: "Leanne Graham",
        },
        {
          value: 2,
          label: "Ervin Howell",
        },
      ],
      series: [],
      // seriesivision: [60, 18, 11, 7],
      // seriesDepartment: [60, 18, 11, 7],
      // seriesJob: [60, 18, 11, 7],
      isMobile: false,
      isMobile450: false,
      isMobile350: false,
      isMobile650: false,
      isMobile900: false,
      isView1300: false,
      height: 0,
      width: 0,
      pageCount: 20,
      userId: 0,
      isRequestLoader: false,

      divisionNameId: 0,
      divisionName: "",
      divisionNameList: [],
      divisionNameEmpty: false,

      departmentNameId: 0,
      departmentName: "",
      departmentNameList: [],
      departmentNameEmpty: false,

      jobDesignationId: 0,
      jobDesignation: "",
      jobDesignationList: [],
      jobDesignationEmpty: false,

      directreportdata: false,
      divisionNamedata: false,
      departmentNamedata: false,
      jobDesignationdata: false,

      directReport: true,

      graphType: "",

      directGraphData: {
        master: 0,
        competent: 0,
        learning: 0,
        novice: 0,
        na: 0,
      },

      divisionGraphData: {
        master: 0,
        competent: 0,
        learning: 0,
        novice: 0,
        na: 0,
      },

      departmentGraphData: {
        master: 0,
        competent: 0,
        learning: 0,
        novice: 0,
        na: 0,
      },

      jobDesignationGraphData: {
        master: 0,
        competent: 0,
        learning: 0,
        novice: 0,
        na: 0,
      },
    };
  }
  componentDidMount() {
    // $("#piechart").replaceWith("rect")
    this.state.isRequestLoader = true;
    this.getDivisionDropDown();
    this.getDepartmentDropDown();
    // this.getDesignationDropDown();
    let user = localStorage.getItem("UserId");
    let userRole = localStorage.getItem("Role");
    this.state.userId = user;
    this.getGraphValue(0, "directreport", 0);
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
    $("body").removeClass("scrollhide");
  }

  resize = () => {
    if (window.innerWidth < 850) {
      this.state.isMobile = true;
    } else {
      this.state.isMobile = false;
    }

    if (window.innerWidth < 900) {
      this.state.isMobile900 = true;
    } else {
      this.state.isMobile900 = false;
    }

    if (window.innerWidth < 350) {
      this.state.isMobile350 = true;
    } else {
      this.state.isMobile350 = false;
    }

    if (window.innerWidth < 650) {
      this.state.isMobile650 = true;
    } else {
      this.state.isMobile650 = false;
    }

    if (window.innerWidth < 450) {
      this.state.isMobile450 = true;
    } else {
      this.state.isMobile450 = false;
    }

    if (window.innerWidth < 1600) {
      this.state.isView1300 = true;
    } else {
      this.state.isView1300 = false;
    }

    this.state.height = window.innerHeight;
    this.state.width = window.innerWidth;
    this.setState({});
  };

  getDivisionDropDown = async () => {
    let apiUrl = `${API.GET_DIVISION_CODE}`;
    // ?pageNumber=${this.state.currentPage}&pageSize=${this.state.perPage}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.divisionNameList = res?.data?.map((divisionName) => {
            return {
              value: divisionName.id + "," + divisionName.value,
              id:divisionName.id,
              label: (
                <>
                  <span>{divisionName.value}</span>
                </>
              ),
            };
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
    // let getDivisionApiUrl = `${API.GET_DIVISION_CODE}`;
    // await axios
    //   .get(getDivisionApiUrl)
    //   .then((response) => {

    //     if (response?.status === 200) {
    //       this.setState({ divisionNameList: response.data })
    //     }

    //   })
    //   .catch(error => {
    //     logoutFunction(error?.response?.status);
    //     console.log(error)
    //   });
  };

  getDepartmentDropDown = async () => {
    let apiUrl = `${API.GET_DEPARTMENT_NAME}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.departmentNameList = res?.data?.map((departmentName) => {
            return {
              value: departmentName.id + "," + departmentName.value,
              id: departmentName.id,
              label: (
                <>
                  <span>{departmentName.value}</span>
                </>
              ),
            };
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
    // let getDeparmentApiUrl = `${API.GET_DEPARTMENT_NAME}`;
    // await axios
    //   .get(getDeparmentApiUrl)
    //   .then((response) => {
    //     if (response?.status === 200) {
    //       this.setState({ departmentNameList: response.data })
    //     }
    //   })
    //   .catch(error => {
    //     logoutFunction(error?.response?.status);
    //     console.log(error)
    //   });
  };

  getDesignationDropDown = async () => {
    let apiUrl = `${API.GET_JOB_DESIGNATION}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.jobDesignationList = res?.data?.map((jobDesignation) => {
            return {
              value: jobDesignation.id + "," + jobDesignation.value,
              id: jobDesignation.id,
              label: (
                <>
                  <span>{jobDesignation.value}</span>
                </>
              ),
            };
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
    // let getDesignationApiUrl = `${API.GET_JOB_DESIGNATION}`;
    // await axios
    //   .get(getDesignationApiUrl)
    //   .then((response) => {
    //     if (response?.status === 200) {
    //       this.setState({ jobDesignationList: response.data })
    //     }
    //   })
    //   .catch(error => {
    //     logoutFunction(error?.response?.status);
    //     console.log(error)
    //   });
  };

  getGraphValue = async (id, field, value) => {
    this.state.series = [];
    let getGraphApiUrl = `${API.GET_SKILL_OVERVIEW}?type=${
      field == "divisionName"
        ? "division"
        : field == "departmentName"
        ? "department"
        : field == "directreport"
        ? "directreport"
        : "jobdesignation"
    }${
      this.state.directReport == false
        ? `&typeId=${id}`
        : `&userId=${this.state.userId}`
    } `;
    // let getGraphApiUrl = `${API.GET_SKILL_OVERVIEW}?type=${(field == "divisionName") ? "division" : (field == "departmentName") ? "department" : (field == "directreport") ? "directreport" : "jobdesignation"}${(this.state.directReport == false) ? `&typeId=${encodeURIComponent(value)}` : `&userId=${this.state.userId}`} `;
    await axios
      .get(getGraphApiUrl)
      .then((response) => {
        if (response?.status === 200) {
          this.state.isRequestLoader = false;
          this.state.directReport = false;
          // let skillChart = Object.keys(response.data);
          // skillChart.map((item, index) => {
          //   if (item == "master") {
          //     this.state.series.push(response.data.master)
          //     this.setState({});
          //   } else if (item == "competent") {
          //     this.state.series.push(response.data.competent)
          //     this.setState({});
          //   } else if (item == "learning") {
          //     this.state.series.push(response.data.learning)
          //     this.setState({});
          //   } else if (item == "novice") {
          //     this.state.series.push(response.data.novice)
          //     this.setState({});
          //   } else if (item == "na") {
          //     this.state.series.push(response.data.na)
          //     this.setState({});
          //     console.log(this.state.series)
          //   }
          // })
          // this.setState({divisionNameList : response.data})
          // ((response.data.master + response.data.competent + response.data.learning + response.data.novice + response.data.na) > 0) ? (this.state.colors = [colors.GREEN, colors.BLUE, colors.ORANGE, colors.YELLOW, colors.BROWN]) : this.state.colors = ["#D3D3D3"]
          if (
            response.data.master > 0 ||
            response.data.competent > 0 ||
            response.data.novice > 0 ||
            response.data.na > 0 ||
            response.data.learning > 0
          ) {
            switch (field) {
              case "directreport":
                this.setState({ directGraphData: response.data });
                this.setState({ [`${field}data`]: true });
                break;
              case "divisionName":
                // let graphData = {
                //   ...this.state.divisionGraphData,
                //   master: response.data?.master || 20,
                //   competent: response.data?.competent || 14,
                //   learning: response.data?.learning || 8
                // }
                this.setState({ divisionGraphData: response.data });
                this.setState({ [`${field}data`]: true });
                break;
              case "departmentName":
                this.setState({ departmentGraphData: response.data });
                this.setState({ [`${field}data`]: true });
                break;
              case "jobDesignation":
                this.setState({ jobDesignationGraphData: response.data });
                this.setState({ [`${field}data`]: true });
                break;
              default:
                break;
            }
          } else {
            this.setState({ [`${field}data`]: false });
          }
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        // alert(error)
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  handleSelectChange = (id, field, value) => {
    value?.length > 0 && (this.state.isRequestLoader = true);
    this.getGraphValue(id, field, value);
    this.setState((prevData) => ({
      ...prevData,
      [`${field}Id`]: 0,
      [field]: value,
      graphType: field,
    }));
  };

  // handleInputChange = (e, field, fieldId) => {
  //   if (e.target.value === "") {
  //     this.setState((prevData) => ({
  //       ...prevData,
  //       // [`${field}Id`]: 0,
  //       [field]: e.target.value,
  //     }));

  //   } else {
  //     this.setState((prevData) => ({
  //       ...prevData,
  //       // [`${field}Id`]: 0,
  //       [field]: e.target.value,
  //     }));
  //   }
  // };

  closeProperties = () => {
    $("body").removeClass("scrollhide");
    // this.state.order = "asc";
    this.setState({});
    // this.sortTable(this.state.sortBy)
  };

  submitToast = () => {
    toast.success("Submitted successfully", {
      position: toast.POSITION.TOP_RIGHT,
      color: "#fff",
    });
  };

  certificateUploadToast = () => {
    toast.success("Certificate uploaded successfully", {
      position: toast.POSITION.TOP_RIGHT,
      color: "#fff",
    });
  };

  renderdivisionName(state, val) {
    return state?.value?.toLowerCase()?.indexOf(val?.toLowerCase()) !== -1;
  }
  renderdepartmentName(state, val) {
    return state?.value?.toLowerCase()?.indexOf(val?.toLowerCase()) !== -1;
  }
  renderjobDesignation(state, val) {
    return state?.value?.toLowerCase()?.indexOf(val?.toLowerCase()) !== -1;
  }

  render() {
    const {
      sortBy,
      order,
      currentUser,
      skillMatrixList,
      supportingRolesList,
      width,
      isMobile,
      directGraphData,
      divisionGraphData,
      departmentGraphData,
      jobDesignationGraphData,
      isRequestLoader,
    } = this.state;
    let { classes, menuToggle } = this.props;

    return (
      <>
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <LoaderVisible isLoader={isRequestLoader} />

        <div
          className={`${
            isMobile
              ? "main-body-mobile  table-responsive-xl"
              : menuToggle
              ? "menu-main-body  table-responsive-xl"
              : "main-body  table-responsive-xl"
          } `}
        >
          {isMobile == true ? (
            <div className="mobile-head border-bottom w-100">
              <div className="col-12 mobile-title">{"Capability overview"}</div>
            </div>
          ) : (
            <div className="head-fixed">
              <div className="title">
                <>
                  <CommonIcon fileName="skilloverviewactive" />
                  <span className="pl-10 head-span">Capability overview</span>
                  {/* <CommonIcon fileName="skilloverviewactive" />
                  <span className="pl-10 head-span mt-10">Capability overview</span> */}
                </>
              </div>
            </div>
          )}

          {/* content  */}
          <div className={` row ml-30 mb-130 scroll-none`}>
            <div
              className={isMobile ? "display-block col" : "display-flex col"}
            >
              <div className="">
                <div
                  className={` ${
                    isMobile ? "skill-matrix-mobile" : "skill-matrix  "
                  }  px-4 pt-10 pb-20 text-20-bold no-wrap min-width-circleoverview mx-2 `}
                >
                  Direct Report
                </div>
                <div className="chart-width">
                  <div className="chart mt-1 mx-2">
                    <Chart
                      options={this.state.options}
                      series={
                        this.state.directreportdata
                          ? [
                              directGraphData.master,
                              directGraphData.competent,
                              directGraphData.learning,
                              directGraphData.novice,
                              directGraphData.na,
                            ]
                          : [0, 0, 0, 0, 0, 100]
                      }
                      type="pie"
                      width="300"
                      height="300"
                    />
                  </div>
                  {this.state.directreportdata ? (
                    <>
                      <div className="display-block legend-overview">
                        <div className="display-flex no-wrap">
                          <div
                            className="square mt-10"
                            style={{
                              backgroundColor: this.state.options.colors[0],
                            }}
                          ></div>
                          <div className="mt-1 mx-2 min-width-legend display-flex">
                            Master
                            <div className="tooltip">
                              <InfoIcon className="info-icon"></InfoIcon>
                              <span class={`tooltiptext text-12-normal`}>
                                {
                                  this.state.directGraphData
                                    .masterProficiencyDescription
                                }
                              </span>
                            </div>
                          </div>{" "}
                          <span className="mx-3 mt-1">
                            {this.state.directGraphData.master + "%"}
                          </span>
                        </div>
                        <div className="display-flex  no-wrap">
                          <div
                            className="square mt-10"
                            style={{
                              backgroundColor: this.state.options.colors[1],
                            }}
                          ></div>
                          <div className="mt-1 mx-2 min-width-legend display-flex">
                            Competent
                            <div className="tooltip">
                              <InfoIcon className="info-icon"></InfoIcon>
                              <span class={`tooltiptext text-12-normal`}>
                                {
                                  this.state.directGraphData
                                    .competentProficiencyDescription
                                }
                              </span>
                            </div>
                          </div>{" "}
                          <span className="mx-3 mt-1">
                            {this.state.directGraphData.competent + "%"}
                          </span>
                        </div>
                        <div className="display-flex  no-wrap">
                          <div
                            className="square mt-10"
                            style={{
                              backgroundColor: this.state.options.colors[2],
                            }}
                          ></div>
                          <div className="mt-1 mx-2 min-width-legend display-flex">
                            Learner
                            <div className="tooltip">
                              <InfoIcon className="info-icon"></InfoIcon>
                              <span class={`tooltiptext text-12-normal`}>
                                {
                                  this.state.directGraphData
                                    .learningProficiencyDescription
                                }
                              </span>
                            </div>
                          </div>{" "}
                          <span className="mx-3 mt-1">
                            {this.state.directGraphData.learning + "%"}
                          </span>
                        </div>
                        <div className="display-flex  no-wrap">
                          <div
                            className="square mt-10"
                            style={{
                              backgroundColor: this.state.options.colors[3],
                            }}
                          ></div>
                          <div className="mt-1 mx-2 min-width-legend display-flex">
                            Novice
                            <div className="tooltip">
                              <InfoIcon className="info-icon"></InfoIcon>
                              <span class={`tooltiptext text-12-normal`}>
                                {
                                  this.state.directGraphData
                                    .noviceProficiencyDescription
                                }
                              </span>
                            </div>
                          </div>{" "}
                          <span className="mx-3 mt-1">
                            {this.state.directGraphData.novice + "%"}
                          </span>
                        </div>
                        {/* <div className="display-flex  no-wrap"><div className="square mt-10" style={{ backgroundColor: this.state.options.colors[4] }}></div > 
                        <div className="mt-1 mx-2 min-width-legend display-flex">NA 
                          <div className="tooltip">
                                    <InfoIcon className="info-icon"></InfoIcon>
                                    <span class={`tooltip-na tooltiptext text-12-normal`}>{this.state.directGraphData.naProficiencyDescription}</span>
                                </div>
                        </div> <span className="mx-3 mt-1">{this.state.directGraphData.na + "%"}</span></div> */}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="display-block legend-overview-nodata">
                        <div className="display-flex no-wrap">
                          <div
                            className="square mt-10"
                            style={{ backgroundColor: "#D3D3D3" }}
                          ></div>{" "}
                          <div className="mt-1 mx-2 min-width-legend">
                            {" "}
                            No records{" "}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="chart-width">
                <div
                  className={` ${
                    isMobile ? "skill-matrix-mobile" : "skill-matrix"
                  }  px-4  pb-10 text-20-bold no-wrap min-width-circleoverview mx-2 `}
                >
                  {/* <div className="basic-multi-select-overview mt-2"> */}
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2`}
                  >
                    <div className="autocomplete-wrappers">
                      {/* <Autocomplete
                        contentEditable={true}
                        value={this.state.divisionName}
                        inputProps={{ placeholder: "Division Name" }}
                        items={this.state.divisionNameList ?? []}
                        getItemValue={(item) => item.value}
                        shouldItemRender={this.renderdivisionName.bind(this)}
                        renderInput={(props) => {
                          return (<input className={`form-control equipment ${this.state.divisionNameEmpty === true ? "autocompleteerror" : ""}`} id="exampleFormControlInput1" required  {...props} />);
                        }}
                        renderMenu={(item) => (
                          item.length > 0 ? <div className="dropdown">{item}</div> : <div className="notext">No options</div>)}
                        renderItem={(item, isHighlighted) => (
                          <div className={`items ${isHighlighted ? "selected-items" : ""}`} title={item.value}>{item.value}</div>)}
                        onChange={(e) => this.handleInputChange(e, "divisionName")}
                        onSelect={(value, item) => this.handleSelectChange(item.id, "divisionName", value)}
                      /> */}
                      <Select
                        className={` text-12-normal-select my-input-class`}
                        classNamePrefix="assigngroups"
                        value={this.state.divisionName}
                        options={this.state.divisionNameList}
                        menuPosition="fixed"
                        menuPlacement="auto"
                        defaultValue={"Select"}
                        placeholder="Division Name"
                        isClearable={true}
                        isMulti={false}
                        isSearchable={true}
                        onChange={(e) => {
                          this.handleSelectChange(
                            e?.id,
                            "divisionName",
                            e?.value?.split(",")[1]
                          );
                          this.setState({ divisionName: e });
                        }}
                      />
                      {this.state.divisionNameEmpty === true ? (
                        <span className="send-rework-label">
                          This field is required
                        </span>
                      ) : (
                        <></>
                      )}
                    </div>{" "}
                    {/* </div> */}
                  </div>
                </div>

                <div className="chart-width">
                  <div className="chart mt-1 mx-2">
                    <Chart
                      options={this.state.options}
                      series={
                        this.state.divisionNamedata
                          ? [
                              divisionGraphData.master,
                              divisionGraphData.competent,
                              divisionGraphData.learning,
                              divisionGraphData.novice,
                              divisionGraphData.na,
                            ]
                          : [0, 0, 0, 0, 0, 100]
                      }
                      type="pie"
                      width="300"
                      height="300"
                    />
                  </div>
                  {this.state.divisionNamedata ? (
                    <>
                      <div className="display-block legend-overview">
                        <div className="display-flex no-wrap">
                          <div
                            className="square mt-10"
                            style={{
                              backgroundColor: this.state.options.colors[0],
                            }}
                          ></div>
                          <div className="mt-1 mx-2 min-width-legend display-flex">
                            {" "}
                            Master
                            <div className="tooltip">
                              <InfoIcon className="info-icon"></InfoIcon>
                              <span class={`tooltiptext text-12-normal`}>
                                {
                                  this.state.divisionGraphData
                                    .masterProficiencyDescription
                                }
                              </span>
                            </div>
                          </div>
                          <span className="mx-3 mt-1">
                            {this.state.divisionGraphData.master + "%"}
                          </span>
                        </div>
                        <div className="display-flex  no-wrap">
                          <div
                            className="square mt-10"
                            style={{
                              backgroundColor: this.state.options.colors[1],
                            }}
                          ></div>
                          <div className="mt-1 mx-2 min-width-legend display-flex">
                            Competent
                            <div className="tooltip">
                              <InfoIcon className="info-icon"></InfoIcon>
                              <span class={`tooltiptext text-12-normal`}>
                                {
                                  this.state.divisionGraphData
                                    .competentProficiencyDescription
                                }
                              </span>
                            </div>
                          </div>
                          <span className="mx-3 mt-1">
                            {this.state.divisionGraphData.competent + "%"}
                          </span>
                        </div>
                        <div className="display-flex  no-wrap">
                          <div
                            className="square mt-10"
                            style={{
                              backgroundColor: this.state.options.colors[2],
                            }}
                          ></div>
                          <div className="mt-1 mx-2 min-width-legend display-flex">
                            Learner
                            <div className="tooltip">
                              <InfoIcon className="info-icon"></InfoIcon>
                              <span class={`tooltiptext text-12-normal`}>
                                {
                                  this.state.divisionGraphData
                                    .learningProficiencyDescription
                                }
                              </span>
                            </div>
                          </div>
                          <span className="mx-3 mt-1">
                            {this.state.divisionGraphData.learning + "%"}
                          </span>
                        </div>
                        <div className="display-flex  no-wrap">
                          <div
                            className="square mt-10"
                            style={{
                              backgroundColor: this.state.options.colors[3],
                            }}
                          ></div>
                          <div className="mt-1 mx-2 min-width-legend display-flex">
                            Novice
                            <div className="tooltip">
                              <InfoIcon className="info-icon"></InfoIcon>
                              <span class={`tooltiptext text-12-normal`}>
                                {
                                  this.state.divisionGraphData
                                    .noviceProficiencyDescription
                                }
                              </span>
                            </div>
                          </div>
                          <span className="mx-3 mt-1">
                            {this.state.divisionGraphData.novice + "%"}
                          </span>
                        </div>
                        {/* <div className="display-flex  no-wrap"><div className="square mt-10" style={{ backgroundColor: this.state.options.colors[4] }}></div > 
                          <div className="mt-1 mx-2 min-width-legend display-flex">NA 
                             <div className="tooltip">
                                <InfoIcon className="info-icon"></InfoIcon>
                                <span class={`tooltip-na tooltiptext text-12-normal`}>{this.state.divisionGraphData.naProficiencyDescription}</span>
                             </div>
                          </div> 
                          <span className="mx-3 mt-1">{this.state.divisionGraphData.na + "%"}</span></div> */}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="display-block legend-overview-nodata">
                        <div className="display-flex no-wrap">
                          <div
                            className="square mt-10"
                            style={{ backgroundColor: "#D3D3D3" }}
                          ></div>{" "}
                          <div className="mt-1 mx-2 min-width-legend">
                            {" "}
                            No records{" "}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div
              className={
                isMobile ? "display-block mt-5 col" : "display-flex mt-5 col"
              }
            >
              <div className="chart-width">
                <div
                  className={` ${
                    isMobile ? "skill-matrix-mobile" : "skill-matrix  "
                  }  px-4  pb-10 text-20-bold no-wrap min-width-circleoverview mx-2  `}
                >
                  {/* <Select
      value={this.state.value}
      placeholder={<div className="text-20-bold">Department Name</div>}

    //   styles={styles}
    //   isClearable={value.some((v) => !v.isFixed)}
      name="colors"
      className="basic-multi-select"
      classNamePrefix="select"
    //   onChange={onChange}
      options={this.state.skills}
    /> */}
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2`}
                  >
                    <div className="autocomplete-wrappers">
                      {/* <Autocomplete
                        contentEditable={true}
                        value={this.state.departmentName}
                        inputProps={{ placeholder: "Department Name" }}
                        items={this.state.departmentNameList ?? []}
                        getItemValue={(item) => item.value}
                        shouldItemRender={this.renderdepartmentName.bind(this)}
                        renderInput={(props) => {
                          return (<input className={`form-control equipment ${this.state.departmentNameEmpty === true ? "autocompleteerror" : ""}`} id="exampleFormControlInput1" required  {...props} />);
                        }}
                        renderMenu={(item) => (
                          item.length > 0 ? <div className="dropdown">{item}</div> : <div className="notext">No options</div>)}
                        renderItem={(item, isHighlighted) => (
                          <div className={`items ${isHighlighted ? "selected-items" : ""}`} title={item.value}>{item.value}</div>)}
                        onChange={(e) => this.handleInputChange(e, "departmentName")}
                        onSelect={(value, item) => this.handleSelectChange(item.id, "departmentName", value)} /> */}
                      <Select
                        className={`text-12-normal-select my-input-class`}
                        classNamePrefix="assigngroups"
                        value={this.state.departmentName}
                        options={this.state.departmentNameList}
                        defaultValue={"Select"}
                        menuPosition="fixed"
                        menuPlacement="auto"
                        placeholder="Department Name"
                        isClearable={true}
                        isMulti={false}
                        isSearchable={true}
                        onChange={(e) => {
                          this.handleSelectChange(
                            e?.id,
                            "departmentName",
                            e?.value?.split(",")[1]
                          );
                          this.setState({ departmentName: e });
                        }}
                      />
                      {this.state.departmentNameEmpty === true ? (
                        <span className="send-rework-label">
                          This field is required
                        </span>
                      ) : (
                        <></>
                      )}
                    </div>
                    {/* </div> */}
                  </div>
                </div>
                <div className="chart-width mx-1">
                  <div className="chart mt-1 mx-2">
                    <Chart
                      options={this.state.options}
                      series={
                        this.state.departmentNamedata
                          ? [
                              departmentGraphData.master,
                              departmentGraphData.competent,
                              departmentGraphData.learning,
                              departmentGraphData.novice,
                              departmentGraphData.na,
                            ]
                          : [0, 0, 0, 0, 0, 100]
                      }
                      type="pie"
                      width="300"
                      height="300"
                    />
                  </div>
                  {this.state.departmentNamedata ? (
                    <>
                      <div className="display-block legend-overview">
                        <div className="display-flex no-wrap">
                          <div
                            className="square mt-10"
                            style={{
                              backgroundColor: this.state.options.colors[0],
                            }}
                          ></div>
                          <div className="mt-1 mx-2 min-width-legend display-flex">
                            {" "}
                            Master
                            <div className="tooltip">
                              <InfoIcon className="info-icon"></InfoIcon>
                              <span class={`tooltiptext text-12-normal`}>
                                {
                                  this.state.divisionGraphData
                                    .masterProficiencyDescription
                                }
                              </span>
                            </div>
                          </div>
                          <span className="mx-3 mt-1">
                            {this.state.departmentGraphData.master + "%"}
                          </span>
                        </div>
                        <div className="display-flex  no-wrap">
                          <div
                            className="square mt-10"
                            style={{
                              backgroundColor: this.state.options.colors[1],
                            }}
                          ></div>
                          <div className="mt-1 mx-2 min-width-legend display-flex">
                            Competent
                            <div className="tooltip">
                              <InfoIcon className="info-icon"></InfoIcon>
                              <span class={`tooltiptext text-12-normal`}>
                                {
                                  this.state.divisionGraphData
                                    .competentProficiencyDescription
                                }
                              </span>
                            </div>
                          </div>
                          <span className="mx-3 mt-1">
                            {this.state.departmentGraphData.competent + "%"}
                          </span>
                        </div>
                        <div className="display-flex  no-wrap">
                          <div
                            className="square mt-10"
                            style={{
                              backgroundColor: this.state.options.colors[2],
                            }}
                          ></div>
                          <div className="mt-1 mx-2 min-width-legend display-flex">
                            Learner
                            <div className="tooltip">
                              <InfoIcon className="info-icon"></InfoIcon>
                              <span class={`tooltiptext text-12-normal`}>
                                {
                                  this.state.divisionGraphData
                                    .learningProficiencyDescription
                                }
                              </span>
                            </div>
                          </div>
                          <span className="mx-3 mt-1">
                            {this.state.departmentGraphData.learning + "%"}
                          </span>
                        </div>
                        <div className="display-flex  no-wrap">
                          <div
                            className="square mt-10"
                            style={{
                              backgroundColor: this.state.options.colors[3],
                            }}
                          ></div>
                          <div className="mt-1 mx-2 min-width-legend display-flex">
                            Novice
                            <div className="tooltip">
                              <InfoIcon className="info-icon"></InfoIcon>
                              <span class={`tooltiptext text-12-normal`}>
                                {
                                  this.state.divisionGraphData
                                    .noviceProficiencyDescription
                                }
                              </span>
                            </div>
                          </div>
                          <span className="mx-3 mt-1">
                            {this.state.departmentGraphData.novice + "%"}
                          </span>
                        </div>
                        {/* <div className="display-flex  no-wrap"><div className="square mt-10" style={{ backgroundColor: this.state.options.colors[4] }}></div > 
                        <div className="mt-1 mx-2 min-width-legend display-flex">NA 
                           <div className="tooltip">
                                <InfoIcon className="info-icon"></InfoIcon>
                                <span class={`tooltip-na tooltiptext text-12-normal`}>{this.state.divisionGraphData.naProficiencyDescription}</span>
                             </div>
                          </div> 
                          <span className="mx-3 mt-1">{this.state.departmentGraphData.na + "%"}</span></div> */}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="display-block legend-overview-nodata">
                        <div className="display-flex no-wrap">
                          <div
                            className="square mt-10"
                            style={{ backgroundColor: "#D3D3D3" }}
                          ></div>{" "}
                          <div className="mt-1 mx-2 min-width-legend">
                            {" "}
                            No records{" "}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="chart-width">
                <div
                  className={` ${
                    isMobile ? "skill-matrix-mobile" : "skill-matrix  "
                  }  px-4  pb-10 text-20-bold no-wrap min-width-circleoverview mx-2`}
                >
                  {/*<div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2`}>
                    <div className="autocomplete-wrappers">
                            <Select
                          className={` text-12-normal-select my-input-class`}
                          classNamePrefix="assigngroups"
                          value={this.state.jobDesignation}
                          options={this.state.jobDesignationList}
                          defaultValue={"Select"}
                          placeholder="Job Designation"
                          isClearable={true}
                          isMulti={false}
                          isSearchable={true}
                          onChange={(e) => {this.handleSelectChange(e?.value?.split(",")[0],"jobDesignation",e?.value?.split(",")[1]); this.setState({jobDesignation : e})}}
                        />
                      {this.state.jobDesignationEmpty === true ? (
                        <span className="send-rework-label">
                          This field is required
                        </span>
                      ) : (<></>)}
                    </div>{" "}

                  </div>
                </div>
                <div >
                  <div className="chart mt-1 mx-2">
                    <Chart
                      options={this.state.options}
                      series={this.state.jobDesignationdata ? [
                        jobDesignationGraphData.master,
                        jobDesignationGraphData.competent,
                        jobDesignationGraphData.learning,
                        jobDesignationGraphData.novice,
                        jobDesignationGraphData.na,
                      ] : [0, 0, 0, 0, 0, 100]}
                      type="pie"
                      width="300"
                      height="300"
                    />
                  </div>
                  {
                    (this.state.jobDesignationdata ?
                      <>
                        <div className="display-block legend-overview">
                        <div className="display-flex no-wrap"><div className="square mt-10" style={{ backgroundColor: this.state.options.colors[0] }}></div > <div className="mt-1 mx-2 min-width-legend"> Master </div> <span className="mx-3 mt-1">{this.state.jobDesignationGraphData.master + "%"}</span></div>
                          <div className="display-flex  no-wrap"><div className="square mt-10" style={{ backgroundColor: this.state.options.colors[1] }}></div > <div className="mt-1 mx-2 min-width-legend">Competent </div> <span className="mx-3 mt-1">{this.state.jobDesignationGraphData.competent + "%"}</span></div>
                          <div className="display-flex  no-wrap"><div className="square mt-10" style={{ backgroundColor: this.state.options.colors[2] }}></div > <div className="mt-1 mx-2 min-width-legend">Learner </div> <span className="mx-3 mt-1">{this.state.jobDesignationGraphData.learning + "%"}</span></div>
                          <div className="display-flex  no-wrap"><div className="square mt-10" style={{ backgroundColor: this.state.options.colors[3] }}></div > <div className="mt-1 mx-2 min-width-legend">Novice </div> <span className="mx-3 mt-1">{this.state.jobDesignationGraphData.novice + "%"}</span></div>
                          <div className="display-flex  no-wrap"><div className="square mt-10" style={{ backgroundColor: this.state.options.colors[4] }}></div > <div className="mt-1 mx-2 min-width-legend">NA </div> <span className="mx-3 mt-1">{this.state.jobDesignationGraphData.na + "%"}</span></div>
                        </div>
                      </> : <>
                        <div className="display-block legend-overview-nodata">
                          <div className="display-flex no-wrap"><div className="square mt-10" style={{ backgroundColor: "#D3D3D3" }}></div > <div className="mt-1 mx-2 min-width-legend"> No records </div></div>
                        </div>
                      </>
                    )
                  }
*/}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <PaginationComponent fetchPagination={this.fetchPaginationList} pageCount={pageCount} /> */}
      </>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SkillOverview);
